import React from "react";
import "./style.scss";
import axios from "axios";
import notifier from "../../utils/notifier.js";
import { useAuth } from "../../context/AuthContext.js";
import { Link, useNavigate } from "react-router-dom";
import { Avatar, IconButton, ListItemIcon, Menu, MenuItem } from "@mui/material";
import DashboardIcon from '@mui/icons-material/Dashboard';
import Logout from '@mui/icons-material/Logout';
import { topIconList } from "../constants/index.js";

// export const API_SERVER = "http://127.0.0.1:8002/api/v1";
export const API_SERVER = process.env.REACT_APP_API_URL;

const Navbar = (props) => {
    const navigate = useNavigate();
    const { logout, user } = useAuth();
    const token = localStorage.getItem("access_token");
    const [anchorEl, setAnchorEl] = React.useState(null);
    const open = Boolean(anchorEl);

    const handleClick = (event) => {
        setAnchorEl(event.currentTarget);
    };
    const handleClose = () => {
        setAnchorEl(null);
    };


    const handleLogout = () => {
        axios
            .post(`${API_SERVER}/auth/logout`, {}, {
                headers: {
                    Authorization: `Bearer ${token}`,
                    Accept: "application/json",
                },
            })
            .then(() => {
                logout();
                navigate.push("/");
                notifier.success("Log Out Successfully");
            })
            .catch((error) => {
                notifier.error(error?.response?.data?.message || error.message);
                console.error(error);
            });

    };

    return (
        <div className="nav-main">
            <div className="header_top_section">
                <div className="container">
                    <div className="row">
                        <div className="col-md-12">
                            <div className="d-md-flex justify-content-between">
                                <ul>
                                    <li className="m-0"><a style={{ color: '#fff' }} onClick={() => window.open(`tel:${"(844) 776-6865"}`)}><img loading='lazy' src="/img/phonel-icon.png"
                                        alt="" /> {"(844) 776-6865"} </a></li>
                                </ul>
                                <ul className="social_icon_top">
                                    {
                                        topIconList.map((icon) => (
                                            <li key={icon.id}><a href="#"><img height='auto' width='auto' loading='lazy' src={icon.img_path} alt="" /></a></li>
                                        ))
                                    }
                                </ul>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div className="navbar">
                <div className="container">

                    <div className="navbar__brand">
                        <Link to="/">
                            <img src="/img/logo.png" alt="ProntoCaseCash Logo" height="40" />
                        </Link>
                    </div>
                    {user ?
                        <>
                            <IconButton
                                onClick={handleClick}
                                size="small"
                                sx={{ ml: 1, padding: "0px", marginLeft: '0px' }}
                                aria-controls={open ? 'account-menu' : undefined}
                                aria-haspopup="true"
                                aria-expanded={open ? 'true' : undefined}
                            >
                                <Avatar sx={{ width: 32, height: 32, padding: "0px", backgroundColor: '#ff6442', }}></Avatar>
                            </IconButton>

                            <Menu
                                anchorEl={anchorEl}
                                id="account-menu"
                                open={open}
                                onClose={handleClose}
                                onClick={handleClose}
                                PaperProps={{
                                    elevation: 0,
                                    sx: {
                                        overflow: 'visible',
                                        filter: 'drop-shadow(0px 2px 8px rgba(0,0,0,0.32))',
                                        mt: 1.5,
                                        '& .MuiAvatar-root': {
                                            ml: -0.5,
                                            mr: 1,
                                        },
                                        '&::before': {
                                            content: '""',
                                            display: 'block',
                                            position: 'absolute',
                                            top: 0,
                                            right: 14,
                                            width: 10,
                                            height: 10,
                                            bgcolor: 'background.paper',
                                            transform: 'translateY(-50%) rotate(45deg)',
                                            zIndex: 0,
                                        },
                                    },
                                }}
                                transformOrigin={{ horizontal: 'right', vertical: 'top' }}
                                anchorOrigin={{ horizontal: 'right', vertical: 'bottom' }}
                            >
                                <Link to={"/dashboard"} style={{ textDecoration: 'none' }}>
                                    <MenuItem style={{ color: 'rgb(117 117 117)' }}>
                                        <ListItemIcon>
                                            <DashboardIcon fontSize="small" />
                                        </ListItemIcon>
                                        <span>Dashboard</span>
                                    </MenuItem>
                                </Link>
                                <MenuItem onClick={handleLogout} style={{ color: 'rgb(117 117 117)', textDecoration: 'none' }}>
                                    <ListItemIcon>
                                        <Logout fontSize="small" />
                                    </ListItemIcon>
                                    <span>Logout</span>
                                </MenuItem>
                            </Menu>
                        </> : null}


                </div>

            </div>
        </div>
    );
};

export default Navbar